import React from 'react'
import styled from 'styled-components'
import Barcode from 'react-barcode'
import { hasThaiString, isASCII } from 'helpers/format'

const ProductBarcode = props => {
  const { barcode, isSmall = true } = props

  const hasInvalidString = hasThaiString(barcode)
  const isAscii = isASCII(barcode)

  if (!isAscii && hasInvalidString) {
    return <div></div>
  }

  const options = {
    background: '#fff',
    height: 30,
  }

  return (
    <SmallWrapper>
      <Barcode value={barcode} options={options} />
    </SmallWrapper>
  )
}

const SmallWrapper = styled.div`
  svg {
    width: 100px;
    height: 30px;
  }
`

export default ProductBarcode
